import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';
import './App.css';
import HelpSupportItems from './components/helpSupportItems/HelpSupportItems';
import ItemDetails from './components/itemDetails/ItemDetails';
import NewHelpSupportItems from './components/newHelpSupportItems/NewHelpSupportItems';
import Footer from './components/shared/footer/Footer';
import MastHead from './components/shared/header/MastHead';
import { ScrollToTopArrow } from './components/shared/ScrollToTopArrow';
import { baseUrl, URLs } from './constants/urls';

function App() {
  return (
    <BrowserRouter>
      <Container fluid={true}
        className="outerContainer">
        <MastHead />
        <Container fluid={true}>
          <Switch>
            <Route path={URLs.itemDetails} exact={true} component={ItemDetails} />
            <Route path={baseUrl} exact={true} component={HelpSupportItems} />
            <Route path={URLs.whatsNew} component={NewHelpSupportItems} />
            <Redirect path="/" exact={true} to={baseUrl} />
          </Switch>
          <div className="go-to-scroll">
            <ScrollToTopArrow />
          </div>
        </Container>
        <Footer />
      </Container>
    </BrowserRouter>
  );
}


export default App;




// WEBPACK FOOTER //
// ./src/App.tsx